
export function getCountries () {
  return process.env.COUNTRIES
}

export function getCountry (countryCode) {
  const code = countryCode.toLowerCase()
  const countries = getCountries()

  return countries[code] ? countries[code] : null
}

export function getCountryByHost () {
  const host = window.location.host
  const countries = getCountries()

  Object.keys(countries).forEach(function (code) {
    if (host === countries[code].url) {
      return countries[code]
    }
  })

  return getCountry('de')
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/locale.js
// module id = 101
// module chunks = 1